import "./index.css";
import {
  SignedIn,
  SignedOut,
  SignInButton,
  UserButton,
} from "@clerk/clerk-react";

export function App() {
  return (
    <div className="app">
      <header>
        <SignedOut>
          <SignInButton />
        </SignedOut>
        <SignedIn>
          <UserButton />
        </SignedIn>
      </header>
      <h1>Supersonic</h1>
      <p>Transcription API</p>
    </div>
  );
}

export default App;
